import Grid from '@mui/material/Grid';
import { observer } from 'mobx-react-lite';
import { Widget } from '../../../../components';
import User from '../../store/User';
import BillingWidget from '../billing';
import AccountWidget from './AccountWidget';
import CdnWidget from './CdnWidget';

export default observer(function UserForm({ user }: { user: User }) {
  return (
    <Grid container spacing={3}>
      <Grid item sm={6}>
        <Widget sx={{ minHeight: 54 }} title="Account">
          <AccountWidget user={user} />
        </Widget>
      </Grid>

      {!user.isCustomer && (
        <Grid item sm={6}>
          <Widget sx={{ minHeight: 10 }} title="Billing">
            <BillingWidget user={user} />
          </Widget>
          {!user.configurations.managedStorage && (
            <Widget sx={{ minHeight: 76, mt: 3 }} title="CDN Settings">
              <CdnWidget user={user} />
            </Widget>
          )}
        </Grid>
      )}
    </Grid>
  );
});
